import { normaliseAddressQuery, type StreetKitAddress, type StreetKitSearchResult } from "@streetkit/shared";

import {
  StreetKitIndexClient,
  type StreetKitClientConfig,
  type StreetKitSearchOptions
} from "./fetch-index.js";
import {
  StreetKitWidgetController,
  type StreetKitWidget,
  type StreetKitWidgetConfig
} from "./streetkit-widget.js";

export * from "./fetch-index.js";
export * from "./rank.js";
export * from "./selection-context.js";
export * from "./streetkit-widget.js";

export type StreetKitClient = {
  search(query: string, options?: StreetKitSearchOptions): Promise<StreetKitSearchResult[]>;
  getDetail(id: string): Promise<StreetKitAddress>;
  clearCache(): void;
};

export type StreetKitGlobal = {
  init(config: StreetKitWidgetConfig): StreetKitWidget;
  createClient(config?: StreetKitClientConfig): StreetKitClient;
  normalizeQuery(query: string): string;
  normaliseQuery(query: string): string;
};

export function init(config: StreetKitWidgetConfig): StreetKitWidget {
  return new StreetKitWidgetController(config);
}

export function createClient(config: StreetKitClientConfig = {}): StreetKitClient {
  const client = new StreetKitIndexClient(config);

  return {
    search(query, options) {
      return client.search(query, options);
    },
    getDetail(id) {
      return client.getDetailById(id);
    },
    clearCache() {
      client.clearCache();
    }
  };
}

export function normalizeQuery(query: string): string {
  return normaliseAddressQuery(query);
}

export const normaliseQuery = normalizeQuery;

export const StreetKit: StreetKitGlobal = {
  init,
  createClient,
  normalizeQuery,
  normaliseQuery
};

declare global {
  interface Window {
    StreetKit?: StreetKitGlobal;
  }
}

if (typeof window !== "undefined") {
  window.StreetKit = StreetKit;
}

export default StreetKit;
